export const baseURL = `/api`;

export const getToken = () => {
  return localStorage.getItem('access_token')
}

export const createHeaders = () => ({
  "Content-Type": "application/json",
  "Authorization": `Bearer ${getToken()}`
  });